import { withInstall } from '@/utils/index'
import BasicTable from './src/BasicTable.vue'

export { BasicTable }

export default withInstall(BasicTable)
